export const defaultContentText = '小拉出行服务司乘两端，主要定位于年轻、高效出行需求的客户群体，提供优惠便利的用车服务，可以满足乘客多场景、随机性、定制化的出行需求；同时，小拉出行将用心服务好平台上的网约车司机，并对平台司机实行“限时免抽佣”政策，助力广大司机师傅快乐接单，提升收入。'

export const defaultOnlineCar = ['成都', '沈阳', '太原', '遵义', '长春', '福州', '东莞', '南充', '贵阳', '苏州', '南平', '日照', '南昌', '桂林', '威海', '盐城', '赣州', '常州', '长沙', '宁波', '重庆', '南宁', '上饶', '杭州', '镇江', '温州', '南通', '广州', '深圳', '泉州', '天津', '惠州', '佛山', '徐州', '合肥', '三亚', '柳州', '株洲', '哈尔滨', '曲靖', '漳州', '淄博', '湖州', '阜阳', '肇庆', '鞍山', '潍坊', '烟台', '临沂', '清远', '金华', '台州', '泸州'
]
export const defaultHitchRide = ['北京', '上海', '广东', '天津', '吉林', '四川', '重庆', '安徽', '山东', '山西', '广西', '江苏', '江西', '河北', '浙江', '海南', '湖南', '福建', '贵州', '辽宁', '黑龙江']

export const defaultHitchRideCityNum = 235

export const defaultRemark = '（信息更新时间：2025年5月，陆续开城中）'

export const defaultInformationList = [
  {
    title: '小拉出行如何‘虎口求生’?',
    source: '虎嗅APP[引用日期2025-05-09]',
    link: 'https://mp.weixin.qq.com/s/_vo1C7Ih6g1Wk0vamT9lsw'
  },
  {
    title: '网约车行业‘最奇葩’的平台！没有中间商赚差价，抽成低至1%?',
    source: '网约车观察[引用日期2025-05-15]',
    link: 'https://mp.weixin.qq.com/s/0QKVjhdyvlte4ZlMkf0qpA'
  },
  {
    title: '小拉出行‘一口价’四面开花，价格战又来了？',
    source: '九派新闻[引用日期2025-05-16]',
    link: 'https://mp.weixin.qq.com/s/imVprj53h1e-ROWgn_KDVA'
  },
  {
    title: '打车价格翻倍？乱收费？网约车行业新生平台如何破局？',
    source: 'AI最前线[引用日期2025-05-18]',
    link: 'https://www.douyin.com/video/7505301019010649396'
  },
  {
    title: '网约车市场大洗牌！小拉出行如何引领变革？',
    source: '财经刘一菲[引用日期2025-05-18]',
    link: 'https://www.douyin.com/video/7505646999347678514'
  },
  {
    title: '【小拉出行】不靠内卷也能打破行业困境？',
    source: '一鸣财经[引用日期2025-05-19]',
    link: 'https://www.douyin.com/user/MS4wLjABAAAA_0YhWOn5ljVopcARIKtajFplrPi2_nHiChaJDJzLOXA?from_tab_name=main&modal_id=7505755035726826793'
  },
  {
    title: '重磅，36个城市抽成1%，网约车行业的拼多多来了！',
    source: '网约车焦点[引用日期2025-05-22]',
    link: 'https://mp.weixin.qq.com/s/e8dCoan8vw4s0Pol5VSIdQ'
  },
  {
    title: '低价突围，小拉出行如何在网约车市场撕开‘新口子’',
    source: '泰山财经[引用日期2025-05-23]',
    link: 'https://tscj.sdnews.com.cn/view/share-article?id=2521'
  }
]
